import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { filterToValidAttributes } from '@zocdoc/dom-property';

export class Dropdown extends Component {
    static propTypes = {
        groupBy: PropTypes.string,
        onChange: PropTypes.func,
        options: PropTypes.array,
        placeholder: PropTypes.string,
        selected: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    };

    static defaultProps = {
        groupBy: null,
        onChange: noop,
        options: [],
        selected: null,
    };

    render() {
        const {
            selected,
            placeholder,
            suppressPlaceholder,
            ...otherProps
        } = this.props;

        const options = this.getOptions();
        const value = selected || placeholder;

        const attributes = filterToValidAttributes(otherProps);

        const placeholderOption = suppressPlaceholder ?
            null : (
                <option
                    disabled
                    value={placeholder}
                >{placeholder}
                </option>
            );

        return (
            <select
                data-prod-guids="dropdown-select:[cfa074a0]"
                data-test="select"
                tabIndex="0"
                {...attributes}
                value={value}
            >
                {placeholderOption}
                {options}
            </select>
        );
    }

    getOptionTag(option) {
        return (
            <option
                key={option.id}
                value={option.id}
            >{option.name}
            </option>
        );
    }

    getOptionTags(options) {
        return options.map(option => this.getOptionTag(option));
    }

    getOptions() {
        const {
            options,
            groupBy,
        } = this.props;

        if (groupBy) return this.getOptgroupTags(options);
        return this.getOptionTags(options);
    }

    getOptgroupTags(groups) {
        const {
            groupBy,
        } = this.props;

        return groups.map(group => {
            const children = this.getOptionTags(group[groupBy]);

            return (
                <optgroup
                    key={group.id}
                    label={group.name}
                >
                    {children}
                </optgroup>
            );
        });
    }
}
